var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HintMessage"},[_c('div',{staticClass:"Important-icon",domProps:{"innerHTML":_vm._s(require('common/icons/Important.svg'))}}),_vm._v(" "),_c('p',{staticClass:"cancellationHint"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }